export default "__VITE_ASSET__c4b761a4__"